import Clock from 'react-live-clock';
export default function LiveClock() {
  return (
    <Clock
        locale={'esp'}
        format={'dddd, MMMM Mo, YYYY, h:mm:ss A'}
        ticking={true}
        timezone={'America/Tegucigalpa'} />
    );
}